var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.value, width: "450" },
      on: { "click:outside": _vm.close }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [_vm._v(" Move Selected Items ")]),
          _c(
            "v-card-text",
            [
              _vm._v(" Select an item group to move the selected items to. "),
              _c("v-autocomplete", {
                attrs: {
                  label: "Item Groups",
                  items: _vm.groupSelections,
                  "item-text": "name",
                  "item-value": "id",
                  clearable: ""
                },
                model: {
                  value: _vm.selectedItemGroup,
                  callback: function($$v) {
                    _vm.selectedItemGroup = $$v
                  },
                  expression: "selectedItemGroup"
                }
              }),
              _vm.selectedItemGroup === "new_group"
                ? _c(
                    "v-form",
                    { ref: "form", attrs: { "lazy-validation": "" } },
                    [
                      _c(
                        "v-row",
                        { staticClass: "mt-2", attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "New Group Name",
                                  rules: [
                                    function(v) {
                                      return !!v || "Group name is required"
                                    }
                                  ],
                                  dense: "",
                                  "validate-on-blur": "",
                                  outlined: ""
                                },
                                model: {
                                  value: _vm.newGroup.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.newGroup, "name", $$v)
                                  },
                                  expression: "newGroup.name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._l(_vm.currentFields, function(field, i) {
                            return _c(
                              "v-col",
                              { key: i, attrs: { cols: "12" } },
                              [
                                field.isBoolean
                                  ? _c("v-checkbox", {
                                      staticClass: "my-auto",
                                      attrs: {
                                        label: field.name,
                                        "hide-details": "auto",
                                        dense: ""
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.setGetItemAllowance(
                                            _vm.newGroup
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.newGroup["" + field.value],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.newGroup,
                                            "" + field.value,
                                            $$v
                                          )
                                        },
                                        expression: "newGroup[`${field.value}`]"
                                      }
                                    })
                                  : field.isInteger
                                  ? _c("v-text-field", {
                                      attrs: {
                                        label: field.name,
                                        type: "number",
                                        min: "0",
                                        step: "1",
                                        suffix: field.suffix,
                                        "background-color": "#fff",
                                        dense: "",
                                        autocomplete: "off",
                                        outlined: ""
                                      },
                                      model: {
                                        value: _vm.newGroup["" + field.value],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.newGroup,
                                            "" + field.value,
                                            $$v
                                          )
                                        },
                                        expression: "newGroup[`${field.value}`]"
                                      }
                                    })
                                  : field.value === "complex_promo_price"
                                  ? _c("v-text-field", {
                                      attrs: {
                                        label: field.name,
                                        disabled: !_vm.showComplexPromoPrice,
                                        type: "number",
                                        min: "0",
                                        step: ".01",
                                        prefix: "$",
                                        rules: _vm.complexPromoPriceRules,
                                        error: _vm.showErrorState(
                                          field,
                                          _vm.newGroup
                                        ),
                                        "background-color": "#fff",
                                        dense: "",
                                        autocomplete: "off",
                                        outlined: ""
                                      },
                                      model: {
                                        value: _vm.newGroup["" + field.value],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.newGroup,
                                            "" + field.value,
                                            $$v
                                          )
                                        },
                                        expression: "newGroup[`${field.value}`]"
                                      }
                                    })
                                  : field.isPercent
                                  ? _c("v-text-field", {
                                      attrs: {
                                        label: field.name,
                                        type: "number",
                                        min: "0",
                                        step: "1",
                                        suffix: "%",
                                        rules: [_vm.isValidPercent],
                                        "background-color": "#fff",
                                        dense: "",
                                        autocomplete: "off",
                                        outlined: ""
                                      },
                                      model: {
                                        value: _vm.newGroup["" + field.value],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.newGroup,
                                            "" + field.value,
                                            $$v
                                          )
                                        },
                                        expression: "newGroup[`${field.value}`]"
                                      }
                                    })
                                  : _c("v-text-field", {
                                      attrs: {
                                        label: field.name,
                                        disabled:
                                          field.value === "promotion_price" &&
                                          _vm.disablePromotionPrice,
                                        type: "number",
                                        min: "0",
                                        step: ".01",
                                        prefix: "$",
                                        rules:
                                          field.value === "promotion_price"
                                            ? _vm.promoPriceRules
                                            : _vm.getPriceRules(field),
                                        error: _vm.showErrorState(
                                          field,
                                          _vm.newGroup
                                        ),
                                        "background-color": "#fff",
                                        dense: "",
                                        autocomplete: "off",
                                        outlined: ""
                                      },
                                      model: {
                                        value: _vm.newGroup["" + field.value],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.newGroup,
                                            "" + field.value,
                                            $$v
                                          )
                                        },
                                        expression: "newGroup[`${field.value}`]"
                                      }
                                    })
                              ],
                              1
                            )
                          }),
                          _vm.isAccrualPromo
                            ? _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      label: "Allowance Type",
                                      items: _vm.accrualAllowanceTypes,
                                      rules: [
                                        function(v) {
                                          return (
                                            !!v ||
                                            "Please select an allowance type"
                                          )
                                        }
                                      ],
                                      "menu-props": { offsetY: true },
                                      outlined: "",
                                      dense: ""
                                    },
                                    model: {
                                      value: _vm.newGroup.allowance_amt_type,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.newGroup,
                                          "allowance_amt_type",
                                          $$v
                                        )
                                      },
                                      expression: "newGroup.allowance_amt_type"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                {
                  attrs: { small: "", text: "", color: "grey darken-2" },
                  on: { click: _vm.close }
                },
                [_vm._v(" Close ")]
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    small: "",
                    disabled: _vm.selectedItemGroup === null,
                    color: "primary"
                  },
                  on: { click: _vm.moveItems }
                },
                [_vm._v(" Move Items ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }